module.exports = __webpack_public_path__ + "static/media/accounting.c7c994fa.svg";